import appBackupSchedules from "../../views/appRoutes/backupSchedules.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "backupschedules";
  const params = ["page", "limit"];

  $stateProvider.state("backupschedules", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appBackupSchedules,
      },
    },
    reloadOnSearch: false,
    data: { title: "Backup Schedules" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/backupSchedules/backupSchedules.urls.js